import { useTranslation } from 'react-i18next';

export default function TestimonialsSection() {
  const { t } = useTranslation();
  
  const testimonials = [
    {
      name: "Jordan Lee",
      content: t('testimonials.jordan.content'),
      company: "Tech Solutions Inc.",
      image: "https://readdy.ai/api/search-image?query=professional%20business%20portrait%20of%20confident%20technology%20executive%20in%20modern%20office%20setting%20with%20clean%20white%20background%20and%20natural%20lighting&width=200&height=200&seq=portrait-jordan-001&orientation=squarish"
    },
    {
      name: "Alex Morgan",
      content: t('testimonials.alex.content'),
      company: "Industrial Dynamics Corp",
      image: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20experienced%20industrial%20manager%20in%20business%20attire%20with%20clean%20white%20background%20and%20professional%20studio%20lighting&width=200&height=200&seq=portrait-alex-002&orientation=squarish"
    },
    {
      name: "Taylor Brooks",
      content: t('testimonials.taylor.content'),
      company: "Manufacturing Excellence Ltd",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20manufacturing%20executive%20in%20modern%20corporate%20environment%20with%20clean%20white%20background%20and%20soft%20lighting&width=200&height=200&seq=portrait-taylor-003&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-emerald-600 font-semibold text-sm uppercase tracking-wide mb-4">
            {t('testimonials.badge')}
          </p>
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-200 mr-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-gray-800">{testimonial.name}</h3>
                  <p className="text-emerald-600 text-sm">{testimonial.company}</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed italic">"{testimonial.content}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
